import React, { FC } from 'react';
import { Card } from 'react-bootstrap';
import { IGameEnvironment } from '../../../model/gameEnvironment/GameEnvironment';

interface PropsType {
    gameEnvironment: IGameEnvironment,
    active: boolean
}

export const GameEnvironmentsOverviewCard: FC<PropsType> = (props) => {

    return <Card key={props.gameEnvironment.id}
                 className={`m3OverviewCard ${props.active ? 'active' : ''}`}>
        <Card.Body className={'cardBody'}>
            <Card.Title className={'cardTitle'}>
                {props.gameEnvironment.name}
            </Card.Title>
            <Card.Subtitle className={'cardSubtitle'}>{props.gameEnvironment.description}</Card.Subtitle>

            {/*<div className={'horizontalListItems'}>*/}
            {/*    <Stack direction="horizontal" gap={2}>*/}
            {/*        <div className={'horizontalListItem'}><i className="fas fa-calendar-alt" />*/}
            {/*            <span>{friendlyDate(props.gameEnvironment.createdAt)}</span></div>*/}
            {/*    </Stack>*/}
            {/*</div>*/}
        </Card.Body>
    </Card>;
};
